import type { RouteRecordRaw } from 'vue-router';
import { CUSTOMER_ROUTE_NAME } from '@/consts';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const customerCheckinListRoutes: RouteRecordRaw = {
  path: '/customer-checkin-list',
  component: () => import('@/layouts/main.vue'),
  meta: { requireAuth: true, requireStoreId: true, i18n },
  children: [
    {
      path: '',
      name: CUSTOMER_ROUTE_NAME.LIST_CUSTOMER_CHECKIN,
      component: () => import('./CustomerCheckinList.vue'),
    },
  ],
};
